import clsx from 'clsx'
import { useIntl } from 'react-intl'
import { Medias } from '../../../enumns/medias'
import { useMediaQuery } from '../../../hooks/useMediaQuery'
import { Header } from '../../landing/components/Header'

export const TermsOfUse = () => {
  const { formatMessage } = useIntl()
  const isTabletSize = useMediaQuery(`(min-width: ${Medias.LG}px)`)

  return (
    <>
    <Header />
    <div className="flex h-full bg-[#CEE2ED]">
      {isTabletSize && (
        <aside className="fixed overflow-y-scroll scrolltransparent top-[88px] left-0 flex flex-col pl-[87px] pr-[20px] pt-[60px] pb-24 h-screen max-w-[400px] w-full justify-start items-start bg-[#A3CBE1]">
        <h1 className="font-openSans mb-12 text-[32px] font-bold text-[#001D2F] mx-auto uppercase">
          {formatMessage({ id: 'INDEX' })}
        </h1>
        {Array.from({ length: 12 }, (_, index) => (
          <a
            key={index}
            className="font-montserrat mb-4 text-base font-semibold text-[#39393A] cursor-pointer"
            onClick={() => {
              const sectionId = [
                'TERMS_OF_USE_SUBTITLE_1',
                'TERMS_OF_USE_SUBTITLE_2',
                'TERMS_OF_USE_SUBTITLE_3',
                'TERMS_OF_USE_SUBTITLE_4',
                'TERMS_OF_USE_SUBTITLE_5',
                'TERMS_OF_USE_SUBTITLE_6',
                'TERMS_OF_USE_SUBTITLE_7',
                'TERMS_OF_USE_SUBTITLE_8',
                'TERMS_OF_USE_SUBTITLE_9',
                'TERMS_OF_USE_SUBTITLE_10',
                'TERMS_OF_USE_SUBTITLE_11',
                'TERMS_OF_USE_SUBTITLE_12',
              ][index]
              const sectionElement = document.getElementById(sectionId)
              if (sectionElement) {
                window.scrollTo({
                  top: sectionElement.offsetTop - 88,
                  behavior: 'smooth'
                })
              }
            }}
          >
            {index + 1}. {formatMessage({ id: `TERMS_OF_USE_SUBTITLE_${index + 1}` })}
          </a>
        ))}
      </aside>
      )}
      <main className={clsx(
        'font-montserrat flex flex-col items-start justify-start w-full px-4 sm:px-16 mt-[88px]',
        isTabletSize ? 'ml-[400px]' : ''
      )}>
        <h1 className="font-openSans mb-16 text-[40px] font-bold text-[#001D2F] uppercase mt-[100px] mx-auto text-center">{formatMessage({ id: 'TRUST_INSIGHT_TERMS_OF_USE' })}</h1>

        <div className="mb-[100px] whitespace-pre-line text-base font-medium text-[#39393A]">
          <h2 className="font-openSans mt-12 mb-4 text-[32px] leading-[48px] font-semibold text-[#39393A]" dangerouslySetInnerHTML={{
            __html: formatMessage({ id: 'TERMS_OF_USE_WELCOME' })
          }}></h2>

          <h2 id="TERMS_OF_USE_SUBTITLE_1" className="font-openSans mt-12 mb-4 text-[32px] leading-[48px] font-semibold text-[#39393A]">{formatMessage({ id: 'TERMS_OF_USE_SUBTITLE_1' })}</h2>
          <span>{formatMessage({ id: 'TERMS_OF_USE_TEXT_1' })}</span>

          <h2 id="TERMS_OF_USE_SUBTITLE_2" className="font-openSans mt-12 mb-4 text-[32px] leading-[48px] font-semibold text-[#39393A]">{formatMessage({ id: 'TERMS_OF_USE_SUBTITLE_2' })}</h2>
          <span>{formatMessage({ id: 'TERMS_OF_USE_TEXT_2' })}</span>

          <h2 id="TERMS_OF_USE_SUBTITLE_3" className="font-openSans mt-12 mb-4 text-[32px] leading-[48px] font-semibold text-[#39393A]">{formatMessage({ id: 'TERMS_OF_USE_SUBTITLE_3' })}</h2>
          <span dangerouslySetInnerHTML={{
            __html: formatMessage({ id: 'TERMS_OF_USE_TEXT_3' })
          }}></span>

          <h2 id="TERMS_OF_USE_SUBTITLE_4" className="font-openSans mt-12 mb-4 text-[32px] leading-[48px] font-semibold text-[#39393A]">{formatMessage({ id: 'TERMS_OF_USE_SUBTITLE_4' })}</h2>
          <span dangerouslySetInnerHTML={{
            __html: formatMessage({ id: 'TERMS_OF_USE_TEXT_4' })
          }}></span>

          <h2 id="TERMS_OF_USE_SUBTITLE_5" className="font-openSans mt-12 mb-4 text-[32px] leading-[48px] font-semibold text-[#39393A]">{formatMessage({ id: 'TERMS_OF_USE_SUBTITLE_5' })}</h2>
          <span>{formatMessage({ id: 'TERMS_OF_USE_TEXT_5' })}</span>

          <ul className="list-disc list-inside mt-6 mb-6">
            <li>
              <span>{formatMessage({ id: 'TERMS_OF_USE_TEXT_5_A' })}</span>
            </li>
          </ul>

          <span>{formatMessage({ id: 'TERMS_OF_USE_TEXT_5_B' })}</span>

          <h2 id="TERMS_OF_USE_SUBTITLE_6" className="font-openSans mt-12 mb-4 text-[32px] leading-[48px] font-semibold text-[#39393A]">{formatMessage({ id: 'TERMS_OF_USE_SUBTITLE_6' })}</h2>
          <span dangerouslySetInnerHTML={{
            __html: formatMessage({ id: 'TERMS_OF_USE_TEXT_6' })
          }}></span>

          <h2 id="TERMS_OF_USE_SUBTITLE_7" className="font-openSans mt-12 mb-4 text-[32px] leading-[48px] font-semibold text-[#39393A]">{formatMessage({ id: 'TERMS_OF_USE_SUBTITLE_7' })}</h2>
          <span dangerouslySetInnerHTML={{
            __html: formatMessage({ id: 'TERMS_OF_USE_TEXT_7' })
          }}></span>

          <h2 id="TERMS_OF_USE_SUBTITLE_8" className="font-openSans mt-12 mb-4 text-[32px] leading-[48px] font-semibold text-[#39393A]">{formatMessage({ id: 'TERMS_OF_USE_SUBTITLE_8' })}</h2>
          <span>{formatMessage({ id: 'TERMS_OF_USE_TEXT_8' })}</span>

          <h2 id="TERMS_OF_USE_SUBTITLE_9" className="font-openSans mt-12 mb-4 text-[32px] leading-[48px] font-semibold text-[#39393A]">{formatMessage({ id: 'TERMS_OF_USE_SUBTITLE_9' })}</h2>
          <span>{formatMessage({ id: 'TERMS_OF_USE_TEXT_9' })}</span>

          <h2 id="TERMS_OF_USE_SUBTITLE_10" className="font-openSans mt-12 mb-4 text-[32px] leading-[48px] font-semibold text-[#39393A]">{formatMessage({ id: 'TERMS_OF_USE_SUBTITLE_10' })}</h2>
          <span>{formatMessage({ id: 'TERMS_OF_USE_TEXT_10' })}</span>

          <h2 id="TERMS_OF_USE_SUBTITLE_11" className="font-openSans mt-12 mb-4 text-[32px] leading-[48px] font-semibold text-[#39393A]">{formatMessage({ id: 'TERMS_OF_USE_SUBTITLE_11' })}</h2>
          <span>{formatMessage({ id: 'TERMS_OF_USE_TEXT_11_A' })}</span>

          <ul className="list-disc list-inside mt-6 mb-6">
            <li>
              <span>{formatMessage({ id: 'TERMS_OF_USE_TEXT_11_B' })}</span>
            </li>
            <li>
              <span>{formatMessage({ id: 'TERMS_OF_USE_TEXT_11_C' })}</span>
            </li>
            <li>
              <span>{formatMessage({ id: 'TERMS_OF_USE_TEXT_11_D' })}</span>
            </li>
            <li>
              <span>{formatMessage({ id: 'TERMS_OF_USE_TEXT_11_E' })}</span>
            </li>
            <li>
              <span>{formatMessage({ id: 'TERMS_OF_USE_TEXT_11_F' })}</span>
            </li>
          </ul>
          <span className="break-all" dangerouslySetInnerHTML={{
            __html: formatMessage({ id: 'TERMS_OF_USE_TEXT_11_G' })
          }}></span>

          <h2 id="TERMS_OF_USE_SUBTITLE_12" className="font-openSans mt-12 mb-4 text-[32px] leading-[48px] font-semibold text-[#39393A]">{formatMessage({ id: 'TERMS_OF_USE_SUBTITLE_12' })}</h2>
          <span>{formatMessage({ id: 'TERMS_OF_USE_TEXT_12_A' })}</span>
          <span className="font-bold">{formatMessage({ id: 'TERMS_OF_USE_TEXT_12_B' })}</span>
        </div>
      </main>
    </div>
    </>
  )
}
